// extracted by mini-css-extract-plugin
export var createdDate = "_ks-1";
export var divider = "_ks-2";
export var headerDivider = "_ks-3";
export var messagesCard = "_ks-0";
export var messagesContainer = "_ks-6";
export var messagesContainerWrapper = "_ks-4";
export var showLeftPanelButton = "_ks-8";
export var topButtons = "_ks-7";
export var withPadding = "_ks-5";